<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <template #item.is_public="{ value: v }">
      <v-icon
        v-if="!!v"
        color="success"
        size="16px"
        class="mr-2"
        v-text="'mdi-eye'"
      />

      <v-icon
        v-else
        size="16px"
        class="mr-2"
        v-text="'mdi-eye-off'"
      />
    </template>

    <template #item.public_status="{ header, data }">
      <span>{{ header.field(data.is_public) }}</span>
    </template>
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/NotificationPages/table-headers'

import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTableNotificationPages',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
